var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',{staticClass:"image-with-gradient-overlay"},[_c('b-col',{staticClass:"outer-container"},[_c('div',{staticClass:"inner-container",class:[
        {'no-bg-img': !_vm.imageUrl},
        {'expand-on-mobile': _vm.expandOnMobile}
      ],style:(_vm.imageUrl && ("background-image: url(" + _vm.imageUrl + ");")),attrs:{"data-testid":"imageWithGradientBackground"}},[_c('div',{staticClass:"content"},[_vm._t("default")],2)])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }